/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useMemo} from 'react'

import {getDisplayPrice} from '../utils/product-utils'

/**
 * @typedef {object} ProductPricing
 * @property {string} currency
 * @property {string} price
 * @property {string} displayPrice
 * @property {boolean} hasDiscount
 */

/**
 * Gets the product pricing, allowing for extensibility using custom hooks
 * @param {object} product
 * @param {boolean} isBonusProduct
 * @return {ProductPricing}
 */
function useProductPricing(product, isBonusProduct) {
    return useMemo(() => {
        if (!product) return null
        const {price, displayPrice, hasDiscount, isFree} = getDisplayPrice(product, isBonusProduct)
        return {
            currency: product.currency,
            price,
            displayPrice,
            hasDiscount,
            isFree
        }
    }, [product, isBonusProduct])
}

export default useProductPricing
